import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"px-0 py-0",attrs:{"fluid":""}},[_c(VImg,{attrs:{"src":_vm.image.s3_url,"height":"250"}}),(_vm.testImages[_vm.keyP])?_c(VListItemSubtitle,[_c('h5',[_c('span',{staticClass:"secondary--text",staticStyle:{"font-family":"'Roboto', sans-serif","font-weight":"normal"}},[_vm._v(_vm._s(_vm.image.description))])])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }